export class DialogConstant {
    public static readonly PANEL_CLASS = 'custom-modal-panel';
}